import React from 'react';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import classes from '../../details.scss';
export function InfoTooltip({
  text,
  isLimitedEdition,
  isSuperSpeedActive
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.customBoxText
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: classes.infoIcon,
    isLimitedEdition: isLimitedEdition
  }), /*#__PURE__*/React.createElement("div", null, isSuperSpeedActive && /*#__PURE__*/React.createElement("p", {
    className: classes.superSpeedText
  }, "This is the only decorating method available for this Super Speed product to meet the Super Speed production timeline."), Boolean(text) && /*#__PURE__*/React.createElement("p", {
    className: isSuperSpeedActive ? classes.text : ''
  }, text)));
}